import { createSelector } from 'reselect';

const getPreEventTasks = state => state.eventChecklist.eventTasks.pre;
const getPostEventTasks = state => state.eventChecklist.eventTasks.post;

const filterCompleted = tasks => tasks.filter(task => task.completedDateTime);
const filterToDo = tasks => tasks.filter(task => !task.completedDateTime)

export const getEventTasksCompleted = createSelector(
  [getPreEventTasks, getPostEventTasks],
  (preTasks, postTasks) => {
    const completedEventTasks = {
      pre: filterCompleted(preTasks),
      post: filterCompleted(postTasks),
    }
    return completedEventTasks;
  }
);

export const getToDoEventTasks = createSelector(
  [getPreEventTasks, getPostEventTasks],
  (preTasks, postTasks) => {
    const toDoEventTasks = {
      pre: filterToDo(preTasks),
      post: filterToDo(postTasks),
    }
    return toDoEventTasks;
  }
);